import { Deserializable } from '../../../models/protocols/deserializable';
import { BaseType } from '../../../models/base/base-type';
import { FiduciaryTypeEnum } from '../enums/fiduciary-type.enum';
import { FiduciaryEntityTypeEnum } from '../enums/fiduciary-entity-type.enum';
import { FiduciaryPowerOfAttorneyTypeEnum } from '../enums/fiduciary-power-of-attorney-type.enum';
import { FiduciaryPowerOfAttorneyAppointmentTypeEnum } from '../enums/fiduciary-power-of-attorney-appointment-type.enum';
import { FiduciaryOrganization } from './fiduciary-organization';
import { FiduciaryIndividual } from './fiduciary-individual';

export class Fiduciary implements Deserializable {
  public id!: number;
  public memberId!: number;
  public typeId!: FiduciaryTypeEnum;
  public entityTypeId!: FiduciaryEntityTypeEnum;
  public powerOfAttorneyTypeId!: FiduciaryPowerOfAttorneyTypeEnum | null;
  public powerOfAttorneyAppointmentTypeId!: FiduciaryPowerOfAttorneyAppointmentTypeEnum | null;
  public appointmentDate!: string;
  public effectiveDate!: string;
  public endDate!: string | null;
  public numberOfAttorneysToMakeAChange!: number | null;
  public note!: string | null;
  public type!: BaseType;
  public entityType!: BaseType;
  public powerOfAttorneyType!: BaseType | null;
  public powerOfAttorneyAppointmentType!: BaseType | null;
  public organizationEntity!: FiduciaryOrganization | null;
  public individualEntities!: FiduciaryIndividual[];

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.organizationEntity) {
      this.organizationEntity = Deserialize.instanceOf(FiduciaryOrganization, this.organizationEntity);
    }
    if (this.individualEntities) {
      this.individualEntities = Deserialize.arrayOf(FiduciaryIndividual, this.individualEntities);
    }
  }
}
